import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import useToggle from 'hooks/use-toggle';
import classNames from 'classnames';
import WidgetTextGridRegularProps
    from 'modules/shared/widgets/components/widget-text-grid-regular/widget-text-grid-regular.props';

import './widget-text-grid-regular.scss';
import Icon from 'atomic/icon';

const WidgetTextGridRegular: React.FC<WidgetTextGridRegularProps> = ({ data, config }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const [showMore, showMoreState] = useToggle(true);

    return (
        <div className="w-text-grid-regular">
            <div className="w-text-grid-regular__title">
                <span>
                    {config?.groupName || 'Pozostałe kategorie'}
                </span>
            </div>
            <div
                className={classNames({
                    'w-text-grid-regular__list': true,
                    'w-text-grid-regular__list--desktop': api.getDevice() === 'desktop',
                    'w-text-grid-regular__list--collapsed': showMore && data.length > 12
                })}
            >
                {data.map(item => (
                    <a
                        key={item.url}
                        href={item.url}
                        className={classNames({
                            'w-text-grid-regular__list__item': true,
                            'w-text-grid-regular__list__item--desktop': api.getDevice() === 'desktop'
                        })}
                    >
                        {item.title}
                        {api.getDevice() !== 'desktop' && (
                            <Icon name="arrow-right" size={16} />
                        )}
                    </a>
                ))}
            </div>
            {data.length > 12 && (
                <div role="button" tabIndex={0} onClick={showMoreState.toggle}
                    className="w-text-grid-regular__show-other"
                >
                    {showMore
                        ? (
                            <>
                                <Icon name="arrow-down" size={16} aria-label="Pokaż pozostałe" />
                                &nbsp;Pokaż pozostałe
                            </>
                        )
                        : (
                            <>
                                <Icon name="arrow-up" size={16} aria-label="Zwiń pozostałe" />
                                &nbsp;Zwiń pozostałe
                            </>
                        )}
                </div>
            )}
        </div>
    );
};

export default WidgetTextGridRegular;
